import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import * as employeeHomeAddressActions from '../actions/employee-home-address.actions';
import { EmployeeHomeAddressResponse } from '../models/employee-home-address.model';

export const employeeHomeAddressFeatureKey = 'employeeHomeAddress';

export interface EmployeeHomeAddressState {
  employeeHomeAddressResponse: EmployeeHomeAddressResponse;
  employeeHomeAddressFailure: IGenericError<ErrorResponse>;
}

export const initialState: EmployeeHomeAddressState = {
  employeeHomeAddressResponse: undefined,
  employeeHomeAddressFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(employeeHomeAddressActions.loadEmployeeHomeAddress, (state, action) => ({
    ...state
  })),
  on(employeeHomeAddressActions.loadEmployeeHomeAddressSuccess, (state, action) => ({
    ...state,
    employeeHomeAddressResponse: action.response
  })),
  on(employeeHomeAddressActions.loadEmployeeHomeAddressFailure, (state, action) => ({
    ...state,
    employeeHomeAddressFailure: action.error
  }))
);

export const getEmployeeHomeAddressResponse = (state: EmployeeHomeAddressState) => {
  return state.employeeHomeAddressResponse;
};
export const getEmployeeHomeAddressFailure = (state: EmployeeHomeAddressState) => state.employeeHomeAddressFailure;
